export default "<r-application-rejection #applicationRejectionRef></r-application-rejection>\n";